export default function () {

    let sessionContainers = document.querySelectorAll('.js-sessionContainer');
    let currSessionContainer = sessionStorage.getItem('sessionContainers');

    for (let i = 0; i < sessionContainers.length; i++) {
        let sessionContainer = sessionContainers[i]
        let sessionContainerID = sessionContainer.getAttribute('id')
        let sessionButton = sessionContainer.querySelector('.js-sessionButton')

        // if the sessionContainerID exists in the obj, then show it...
        if (currSessionContainer !== null && currSessionContainer.indexOf(sessionContainerID) > -1) {
            sessionContainer.style.display = 'none';
        } else {
            sessionContainer.style.display = 'block';
        }

        if (sessionButton !== null) {
            sessionButton.addEventListener('click', function (e) {
                e.preventDefault();
                let currSessionContainers = sessionStorage.getItem('sessionContainers')
                let sessionContainers = []

                if (currSessionContainers === null) {
                    // nothing in it, so add
                    sessionContainers.push(sessionContainerID)
                    sessionStorage.setItem('sessionContainers', JSON.stringify(sessionContainers));
                } else {
                    let existingSessionContainers = JSON.parse(sessionStorage.getItem('sessionContainers'));
                    existingSessionContainers.push(sessionContainerID)
                    sessionStorage.setItem('sessionContainers', JSON.stringify(existingSessionContainers));
                }
                sessionContainer.style.display = "none";
                adjustAlertHeader()
                adjustNavigationHeights();
            })
        }
    }

    let sessionPreviewContainers = document.querySelectorAll('.js-sessionContainer-preview');

    for (let i = 0; i < sessionPreviewContainers.length; i++) {
        let sessionContainer = sessionPreviewContainers[i];
        let sessionButton = sessionContainer.querySelector('.js-sessionButton');

        sessionContainer.style.display = `block`;

        sessionButton.addEventListener('click', function (e) {
            e.preventDefault();
            sessionContainer.style.display = "none";
            adjustAlertHeader()
            adjustNavigationHeights();
        });
    }

    function adjustAlertHeader() {
        if (!!document.querySelectorAll(`.Alert--header`).length === true) {
            let headerHeight = document.querySelector(`.PageNav`).offsetHeight;
            document.body.style.paddingTop = `${headerHeight}px`;
        }
    }

    function adjustNavigationHeights() {
        let menuSessions = document.getElementsByClassName('session-menu');
        
        for (let i = 0; i < menuSessions.length; i++) {
            let menuSession = menuSessions[i];
            menuSession.classList.remove('session-menu');
        }
    }

    adjustAlertHeader()

    if (!!document.querySelectorAll(`.Alert--header`).length === true) {
        window.onresize = function () {
            adjustAlertHeader()
        }
    }


}